import {useMutation, useQueryClient} from '@tanstack/react-query'

import {downloadWorkerImportTemplate, importWorkersCsv, previewWorkerImport} from './api'
import {workerKeys} from './query-keys'

export function useDownloadWorkerImportTemplate() {
    return useMutation({
        mutationFn: () => downloadWorkerImportTemplate(),
    })
}

export function usePreviewWorkerImport() {
    return useMutation({
        mutationFn: (file: File) => previewWorkerImport(file),
    })
}

export function useImportWorkersCsv() {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (file: File) => importWorkersCsv(file),
        onSuccess: (result) => {
            if (result.importedCount > 0) {
                void queryClient.invalidateQueries({queryKey: workerKeys.all})
            }
        },
    })
}
